import React from "react"
import PropTypes from "prop-types"
import { useStaticQuery, graphql } from "gatsby"

import { Container } from "react-bootstrap"
import Footer from "./Footer"
import "../styles/modal.css"

const Layout = ({ children }) => {
	return (
		<>
			<Container fluid className="px-0 white app-container">
				<Container fluid className="pt-5 mt-5 min-vh-100 text-center">
					{children}
				</Container>
				<Footer />
			</Container>    </>
	)
}

Layout.propTypes = {
	children: PropTypes.node.isRequired,
}

export default Layout
//
// import React from 'react'
// import PropTypes from 'prop-types'
// import Helmet from 'react-helmet'
// import { StaticQuery, graphql } from 'gatsby'
// 
// import Header from './header'
// import './layout.css'
// 
// const Layout = ({ children, data }) => (
//   <StaticQuery
//     query={graphql`
//       query SiteTitleQuery {
//         site {
//           siteMetadata {
//             title
//           }
//         }
//       }
//     `}
//     render={data => (
//       <>
//         <Helmet
//           title={data.site.siteMetadata.title}
//           meta={[
//             { name: 'description', content: 'Sample' },
//             { name: 'keywords', content: 'sample, something' },
//           ]}
//         >
//           <html lang="en" />
//         </Helmet>
//         <Header siteTitle={data.site.siteMetadata.title} />
//         <div
//           style={{
//             margin: '0 auto',
//             maxWidth: 960,
//             padding: '0px 1.0875rem 1.45rem',
//             paddingTop: 0,
//           }}
//         >
//           {children}
//         </div>
//       </>
//     )}
//   />
// )
// 
// Layout.propTypes = {
//   children: PropTypes.node.isRequired,
// }
// 
// export default Layout
